import React, { useRef, useState } from 'react';
import { Pagina } from '../../componentes/pagina';
import { usePdf } from '@mikecousins/react-pdf';

export default function Politica() {
    const [page, setPage] = useState(1);
    const [arquivo, setArquivo] = useState('./pdf/POLITICA_AMBIENTAL_2025.pdf'); // Nome simplificado sem caracteres especiais
    const canvasRef = useRef(null);

    const mudarArquivo = (novoArquivo) => {
        setArquivo(novoArquivo);
        setPage(1); // Reinicia na página 1 ao trocar de relatório
    };

    const abrirPDF = (url) => {
        window.open(url, '_blank');
    };

    const { pdfDocument } = usePdf({
        file: arquivo,
        page,
        canvasRef,
    });

    return (
        <>
            

            {/* Página com o visualizador de PDF */}
            <Pagina titulo="Políticas Grupo Aval">

                {/* Seção para troca de relatórios */}
            <div className="troca-pdf">
                <button className="ui button" style={{ marginBottom: '10px' }} onClick={() => mudarArquivo('./pdf/POLITICA_AMBIENTAL_2025.pdf')}>
                    Política Ambiental
                </button>
                <button className="ui button" style={{ marginBottom: '10px' }} onClick={() => mudarArquivo('./pdf/POLITICA_DE_DIREITOS_HUMANOS_2025.pdf')}>
                    Política de Direitos Humanos
                </button>
                <button className="ui button" style={{ marginBottom: '10px' }} onClick={() => mudarArquivo('./pdf/POLITICA_DE_SAUDE_SEGURANÇA_DO_TRABALHO_2025.pdf')}>
                    Política de Saúde e Segurnça do Trabalho
                </button>
                
            </div>
            <div className="pdf" style={{ cursor: 'pointer' }} onClick={() => abrirPDF(arquivo)}>
                    {!pdfDocument ? (
                        <span>Carregando...</span>
                    ) : (
                        <canvas ref={canvasRef} />
                    )}
                
            </div>
                {/* Controles de navegação do PDF */}
                {pdfDocument && pdfDocument.numPages > 1 && (
                    <nav>
                        <button
                            className="ui button"
                            disabled={page === 1}
                            onClick={() => setPage(page - 1)}
                        >
                            Anterior
                        </button>
                        <button
                            className="ui button"
                            disabled={page === pdfDocument.numPages}
                            onClick={() => setPage(page + 1)}
                        >
                            Próximo
                        </button>
                        <button 
                            className="ui button" 
                            onClick={() => abrirPDF(arquivo)}
                        >
                            Expandir arquivo
                        </button>
                    </nav>
                )}
                
            </Pagina>
        </>
    );
}
